export default "<span errorHandling [shouldDisplayErrorInDialog]=\"false\"></span>\r\n<router-outlet></router-outlet>"